import { useEffect, useState } from "react";

/**
 * Détecte l'OS mobile de l'utilisateur (iOS / Android / other) via
 * userAgent. `hydrated` passe à `true` après le premier effet côté
 * client — utile pour éviter les mismatches SSR/CSR quand on affiche
 * un CTA différent selon l'OS.
 */
export default function useDeviceOS() {
  const [os, setOs] = useState("other");
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    if (typeof navigator === "undefined") return;
    const ua = (navigator.userAgent || navigator.vendor || "").toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua) || (/macintosh/.test(ua) && "ontouchend" in document);
    const isAndroid = /android/.test(ua);
    setOs(isIOS ? "ios" : isAndroid ? "android" : "other");
    setHydrated(true);
  }, []);
  return { os, hydrated };
}
